import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (19.994 / 24);
  const localHeight = size * (21.994 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 19.994 21.994">
      <g transform="translate(-16 -56)">
        <g transform="translate(-24)">
          <g transform="translate(40 56)" fill="none" strokeLinecap="round">
            <path
              d="M9.5,0A9.5,9.5,0,1,1,0,9.5,9.5,9.5,0,0,1,9.5,0Z"
              stroke="none"
            />
            <path
              d="M 9.4991455078125 1.999996185302734 C 5.364095687866211 1.999996185302734 1.999996185302734 5.364095687866211 1.999996185302734 9.4991455078125 C 1.999996185302734 13.63419532775879 5.364095687866211 16.99829483032227 9.4991455078125 16.99829483032227 C 13.63419532775879 16.99829483032227 16.99829483032227 13.63419532775879 16.99829483032227 9.4991455078125 C 16.99829483032227 5.364095687866211 13.63419532775879 1.999996185302734 9.4991455078125 1.999996185302734 M 9.4991455078125 -3.814697265625e-06 C 14.74537563323975 -3.814697265625e-06 18.99829483032227 4.252915382385254 18.99829483032227 9.4991455078125 C 18.99829483032227 14.74537563323975 14.74537563323975 18.99829483032227 9.4991455078125 18.99829483032227 C 4.252915382385254 18.99829483032227 -3.814697265625e-06 14.74537563323975 -3.814697265625e-06 9.4991455078125 C -3.814697265625e-06 4.252915382385254 4.252915382385254 -3.814697265625e-06 9.4991455078125 -3.814697265625e-06 Z"
              stroke="none"
              fill={localColor}
            />
          </g>
          <path
            id="Path_1"
            data-name="Path 1"
            d="M1281.041,1200.041,1277,1196"
            transform="translate(-1222.461 -1123.461)"
            fill="none"
            stroke={localColor}
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Index;
